export default __webpack_public_path__ + "static/media/step1sell.5feb108d.png";